<template>
  <div class="structured-description lublin-page">
    <BasePreloader v-if="loading" />

    <template v-else-if="pageData">
      <LublinFirstSection :section-data="pageData.block1" />
      <LublinSecondSection :section-data="pageData.block2" />
      <LublinThirdSection :section-data="pageData.block3" />
      <LublinProjectStages :section-data="pageData.block4" />
      <LublinResourcesSection :section-data="pageData.block5" />
      <LublinFaqSection :section-data="pageData.block6" />
      <LublinDescriptionSection :section-data="pageData.block7" />
    </template>
  </div>
</template>

<script>
import {http} from '../../axios';
import globalMetaMixin from '../../mixins/globalMetaMixin';
import LublinFirstSection from '../../components/aboutCities/Lublin/LublinFirstSection';
import LublinSecondSection from '../../components/aboutCities/Lublin/LublinSecondSection';
import LublinThirdSection from '../../components/aboutCities/Lublin/LublinThirdSection';
import LublinProjectStages from '../../components/aboutCities/Lublin/LublinProjectStages';
import LublinResourcesSection from '../../components/aboutCities/Lublin/LublinResourcesSection';
import LublinFaqSection from '../../components/aboutCities/Lublin/LublinFaqSection';
import LublinDescriptionSection from '../../components/aboutCities/Lublin/LublinDescriptionSection';

export default {
  name: 'LublinPage',
  mixins: [globalMetaMixin],
  components: {
    LublinDescriptionSection,
    LublinFaqSection,
    LublinResourcesSection,
    LublinProjectStages,
    LublinThirdSection,
    LublinFirstSection,
    LublinSecondSection,
  },
  data() {
    return {
      loading: false,
      pageData: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;

      try {
        const { data } = await http.get('/api/helper/landing/city/lublin');
        this.pageData = data;

        this.setMetaTitleMixin(data.header.meta_title);
        this.setMetaDescriptionMixin(data.header.meta_description);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
